import React, { Component } from 'react';
import { array, func, object, string } from 'prop-types';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import ChangeTrendIntervalModal from '../Modals/ChangeTrendIntervalModal';
import EsmsPage from '../../components/EsmsPage';
import ProfilesTable from './ProfilesTable';

import CreateProfileModal from '../Modals/CreateProfileModal';
import DeleteProfileModal from '../Modals/DeleteProfileModal';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import * as ProfileActions from '../../actions/profileActions';
import { enqueueSnackbar } from '../../actions/applicationMessageActions';

class ProfilesPage extends Component {
    static defaultProps = {
        fetchProfiles:    () => {},
        selectedProfiles: []
    }
    static propTypes = {
        companyInfo:         object,
        currentScopes:       array,
        history:             object,
        enqueueSnackbar:     func,
        fetchProfiles:       func,
        order:               string,
        orderBy:             string,
        profiles:            array,
        reorderProfiles:     func,
        selectedProfiles:    array,
        toggleSelectProfile: func,
        updateProfile:       func
    }

    state = {
        changeTrendIntervalModalOpen: false,
        createProfileModalOpen:       false,
        deleteProfileModalOpen:       false,
        profilesToDelete:             [],
        selectedProfile:              null,
        selectState:                  [],
        workbookModeEnabled:          false
    }

    async componentDidMount() {
        const { companyInfo } = this.props;
        await this.props.fetchProfiles(companyInfo.companyId);
        this.props.fetchBasTypes();
    }

    handleSort = (property) => {
        return (event) => {
            this.props.reorderProfiles(property);
        };
    }

    handlePageRoute = () => {
        const { history, location } = this.props;

        history.push('/iothub' + location.search);
    }

    handleCreateProfile = () => {
        this.setState({
            createProfileModalOpen: true
        });
    }

    handleDelete = (profile) => {
        this.setState({
            deleteProfileModalOpen: true,
            profilesToDelete:       [profile]
        });
    }

    handleTrendChange = (selectedProfile) => {
        this.setState({
            changeTrendIntervalModalOpen: true,
            selectedProfile
        });
    }

    handleDeleteSelected = () => {
        const hasNonCustomProfiles = this.state.profilesToDelete.some(({ profileType }) => profileType !== 'Custom');
        if (hasNonCustomProfiles) {
            this.props.enqueueSnackbar('Cannot delete non-Custom profiles!', 'error');
            return;
        }
        this.setState({
            deleteProfileModalOpen: true
        });
    }

    handleSearch = (searchFilter) => {
        const { companyInfo } = this.props;
        this.props.fetchProfiles(companyInfo.companyId, { searchFilter });
    }

    handleCloseChangeTrendIntervalModal = () => {
        this.setState({
            changeTrendIntervalModalOpen: false,
            selectedProfile:              null
        });
    }

    handleCloseCreateProfile = () => {
        this.setState({
            createProfileModalOpen: false,
        });
    }

    handleCloseDeleteProfileModal = () => {
        this.setState({
            deleteProfileModalOpen: false,
            profilesToDelete:       []
        });
    }

    toggleWorkbookMode = () => {
        this.setState({
            workbookModeEnabled: !this.state.workbookModeEnabled
        });
    }

    updateSelectedState = profiles => {
        this.setState({
            selectState: profiles
        });
    }

    render() {
        let {
            companyInfo,
            order,
            profiles,
            toggleSelectProfile,
            updateProfile
        } = this.props;
        const isFullProfileAllowed = isAllowed(this.props.currentScopes, Permissions('iothubFull'));

        let profilesToDelete = this.state.profilesToDelete;
        if (!profilesToDelete.length) {
            Object.keys(this.state.selectState).forEach(key => {
                if (this.state.selectState[key] === false) {
                    delete this.state.selectState[key];
                }
            });

            profilesToDelete = Object.keys(this.state.selectState).map(key => ({ id: key }));
            profilesToDelete.forEach(item => {
                const found = profiles.find(profile => profile.id === item.id);

                if (found) item.name = found.name;
            });
        }
        return (
            <React.Fragment>
                <EsmsPage
                    parents={[companyInfo.companyName]}
                    title="Profiles"
                    handlers={[this.handlePageRoute]}
                >
                    <ActionBar
                        onSearch={this.handleSearch}
                    >
                        <ActionBarItem
                            onClick={this.toggleWorkbookMode}
                            type="edit"
                        >
                            Workbook Mode
                        </ActionBarItem>
                        <ActionBarItem
                            onClick={this.handleCreateProfile}
                            type="add"
                            hidden={!isFullProfileAllowed}
                        >
                            Create Profile
                        </ActionBarItem>
                        <ActionBarItem
                            disabled={!Object.values(this.state.selectState).find(item => item === true)}
                            onClick={this.handleDeleteSelected}
                            type="delete"
                            hidden={!isFullProfileAllowed}
                        >
                            Delete Profiles
                        </ActionBarItem>
                    </ActionBar>
                    <ProfilesTable
                        isFullProfileAllowed={isFullProfileAllowed}
                        order={order}
                        onDeleteModal={this.handleDelete}
                        onChangeTrendModal={this.handleTrendChange}
                        onItemChange={updateProfile}
                        onItemToggle={toggleSelectProfile}
                        onSort={this.handleSort}
                        profiles={profiles}
                        workbookModeEnabled={this.state.workbookModeEnabled}
                        updateSelectedState={this.updateSelectedState}
                    />
                </EsmsPage>
                <CreateProfileModal
                    open={this.state.createProfileModalOpen}
                    close={this.handleCloseCreateProfile}
                    title={'Create Profile'}
                />
                <DeleteProfileModal
                    open={this.state.deleteProfileModalOpen}
                    close={this.handleCloseDeleteProfileModal}
                    profiles={profilesToDelete}
                />
                <ChangeTrendIntervalModal
                    onClose={this.handleCloseChangeTrendIntervalModal}
                    open={this.state.changeTrendIntervalModalOpen}
                    profile={this.state.selectedProfile}
                />
            </React.Fragment>
        );
    }
}

export const mapStateToProps = state => {
    const { profiles, order, orderBy: orderByKey } = state.profile;
    return {
        companyInfo:      state.companyInfo,
        currentScopes:    state.core.currentScopes,
        message:          state.messages.message,
        order,
        orderBy:          orderByKey,
        profiles:         profiles,
        selectedProfiles: profiles.filter(({ isSelected }) => isSelected)
    };
};

const mapDispatchToProps = {
    enqueueSnackbar,
    ...ProfileActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfilesPage));
